import { connect } from 'react-redux'
import { GameRoomListCard } from '../components'
import * as actions from '../../../actions'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { user } = state.authentication
  const { language } = state.user
  return ({
    width,
    user,
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    unmount: () => {
      dispatch(actions.gameRoomListCard.changedGroup(undefined))
    },
    handleChangeGroup: (currentGroup) => (event) => {
      dispatch(actions.gameRoomListCard.changedGroup(event.target.value))
    }, 
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GameRoomListCard)


// WEBPACK FOOTER //
// ./src/Pages/Game/containers/GameRoomListCard.js